import { useState, useRef, useEffect } from "react";
import WithSidebar from "../../layouts/WithSidebar";
import "./offices.css"
import List from '../../components/List'
import Input from "../../blocks/Input";
import { useForm } from "../../hooks/useForm";
import OfficesHeader from "../../components/Offices-headers";
import { ajax } from "../../scripts/helper";
import utils from "../../scripts/utils";
import { useSnackbar } from 'notistack'
import context from '../../scripts/context'

const Offices = () => {

    const officeInputFilter = context.getOfficeInputFilter()
    const {enqueueSnackbar} = useSnackbar()
    const [data, setData] = useState([])
    const [page, setPage] = useState(officeInputFilter.page)
    const [totalCounts, setTotalCounts] = useState(officeInputFilter.totalCounts)
    const [rowsPerPage, setRowsPerPage] = useState(officeInputFilter.rowsPerPage)

    const headers = [
        {name: 'ID'},
        {name: 'Code'},
        {name: 'Email'},
        {name: 'Phone'},
        {name: 'Mobile'},
        {name: 'Contact'},
        {name: 'Payment status'},
        {name: 'Status'},
        {name: 'Actions'},
    ]
    
    const makeParams = (inputs)=>{

        console.log(inputs, ' input ijfadiughdgdfjg')
        let params = ''
        let count = 0
        Object.keys(inputs).forEach( (e) => {
            if(inputs[e].type !== 'select' && inputs[e].value ) {
                    params += `&${inputs[e].name}=${inputs[e].value}`
                    count ++
            }
            if(inputs[e].type === 'select' && inputs[e].value) {
                params += `&${inputs[e].name}=${inputs[e].selected}`
                count ++
            }
        })
        // setFilterNumber(count)
        return {params, count}
    }

    const firstParams = makeParams(officeInputFilter)
    const [params, setParams] = useState(firstParams.params)
    const [filterNumber, setFilterNumber] = useState(firstParams.count)




    const actions = {
       onChangeOfficeStatus: async(row) => {
        changeOfficeStatus(row)
       },
       onChangePaymentStatus: async(row) => {
        changePaymentStatus(row)
       }
    }

    const changePaymentStatus = async (row) => {
        let newStatus = ''
        if(row.paymentStatus ==='ACTIVE') newStatus = 'BLOCK'

        if(row.paymentStatus === 'BLOCK') newStatus = 'ACTIVE'

        const res = await ajax({
            method: 'PUT',
            url: utils.urls.updateOffice(row.id),
            hasToken: true,
            snackbar: enqueueSnackbar,
            data: {
                paymentStatus: newStatus
            }
        })

        if(!res) return
        
        setData(data.map(d => {
            if(d.id === res.data.id) return res.data
            return d
        }))

    }


    const changeOfficeStatus = async (row) => {
        let newStatus = ''
        if(row.status ==='ACTIVE') newStatus = 'BLOCK'

        if(row.status ==='BLOCK') newStatus = 'ACTIVE'

        const res = await ajax({
            method: 'PUT',
            url: utils.urls.updateOffice(row.id),
            hasToken: true,
            snackbar: enqueueSnackbar,
            data: {
                status: newStatus
            }
        })

        if(!res) return
        
        setData(data.map(d => {
            if(d.id === res.data.id) return res.data
            return d
        }))
    }

    const getOffices = async (page) => {

        const res = await ajax({
            method: 'GET',
            url: utils.urls.officeList + `?size=${context.getOfficeInputFilter().rowsPerPage}&page=${page}${params}`,
            hasToken: true,
            snackbar: enqueueSnackbar
        })

        if(!res) return

        setData(res.data.content)
        context.setOfficeInputFilter({
            ...context.getOfficeInputFilter(),
            totalCounts: res.data.totalElements
        })
        // setTotalCounts(res.data.totalElements)
        
    }

    const onPageChange = (page, rowsPerPage=10) => {
        context.setOfficeInputFilter({
            ...context.getOfficeInputFilter(),
            page:page,
            rowsPerPage: rowsPerPage
        })
        setPage(page)
        setRowsPerPage(rowsPerPage)
        getOffices(page)
    }

    const onFilter = (inputs) => {
        console.log(inputs,'inputs ee jadid')

        const params = makeParams(inputs).params
        setFilterNumber(makeParams(inputs).count)
        context.setOfficeInputFilter({
            ...inputs,
            page: 0
        })
        setPage(0)
        setParams(params)
    }

    useEffect( () => {
        getOffices(page)
    }, [params])



    return (
        <WithSidebar pageTitle={" Office Management"} breadcrumb={"Dashboard > Office"} listHeaders={<OfficesHeader onFilter={(inputs) => onFilter(inputs)} count={filterNumber}/>}>
            <List columns={headers} rows={data} type={"offices"} page={page} totalCounts={totalCounts} rowsPerPage={rowsPerPage} onPageChange={ (page, rowsPerPage) => onPageChange(page, rowsPerPage)} actions={actions}/>
        </WithSidebar>
    )

}

export default Offices